import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { LIST, VIEW } from "const"
import {
    replaceHistoryState,
    hasAccess,
} from "client/utils"
import {
    okrSessionsRoute,
    okrObjectivesAllRoute,
    okrObjectivesNestedRoute,
    okrObjectivesTreeRoute,
    okrKeyResultsRoute,
} from "client/parts/routes"
import {
    PRM_OKR_OBJECTIVE_KEY_RESULT,
    StoreType,

    setOkrObjectiveBaseRoute,
    setOkrObjectiveRoute,
    setUrlOrigin,
    addModal,
} from "client/store"
import {
    Container,
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import ListAll from "./listAll"

interface ObjectiveListProps {
    sessionId: number
    objectiveId: number
    keyResultId: number
    action: string
    search: string // inbuilt router property
}

const ObjectiveList = ({
    sessionId = null,
    objectiveId = null,
    keyResultId = null,
    action = null,
    search,
}: ObjectiveListProps) => {
    const session = useSelector((state: StoreType) => state.okrSession.sessionView)
    const objectiveBaseRoute = useSelector((state: StoreType) => state.okrObjective.baseRoute)
    const objectiveRoute = useSelector((state: StoreType) => state.okrObjective.objectiveRoute)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [modalOpened, setModalOpened] = useState(false)
    const [dataLoaded, setDataLoaded] = useState(false)

    useEffect(() => {
        dispatch(setOkrObjectiveBaseRoute(`${okrSessionsRoute}/${VIEW}/${sessionId}`))
    }, [])

    useEffect(() => {
        if (modalOpened) return
        if (!dataLoaded) return
        if (!objectiveBaseRoute || !objectiveRoute) return

        const baseRoute = `${objectiveBaseRoute}${objectiveRoute}`
        dispatch(setUrlOrigin(baseRoute))
        setModalOpened(true)

        if (sessionId !== null && objectiveId !== null && keyResultId === null) {
            dispatch(addModal({ url: `${baseRoute}/${action}/${objectiveId}${search}` }))
        }

        if (sessionId !== null && objectiveId !== null && keyResultId !== null) {
            dispatch(addModal({ url: `${baseRoute}/${VIEW}/${objectiveId}${okrKeyResultsRoute}/${action}/${keyResultId}` }))
        }
    }, [modalOpened, dataLoaded, objectiveBaseRoute, objectiveRoute])

    const handleMenuClick = (newObjectiveRoute: string) => {
        const newRoute = `${objectiveBaseRoute}${newObjectiveRoute}`
        dispatch(setOkrObjectiveRoute(newObjectiveRoute))
        dispatch(setUrlOrigin(newRoute))
        replaceHistoryState(newRoute)
    }

    const isOwnerSession = session.owner === userData.userId
    const listAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, LIST) || isOwnerSession

    if (!listAccess) return <AccessDenied />
    return (
        <Container>
            <PageContent>
                <PageMenu>
                    <PageMenuButton
                        isActive={objectiveRoute === okrObjectivesAllRoute}
                        onClick={() => handleMenuClick(okrObjectivesAllRoute)}
                    >
                        {lang.objectives}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={objectiveRoute === okrObjectivesNestedRoute}
                        onClick={() => handleMenuClick(okrObjectivesNestedRoute)}
                    >
                        {lang.nested}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={objectiveRoute === okrObjectivesTreeRoute}
                        onClick={() => handleMenuClick(okrObjectivesTreeRoute)}
                    >
                        {lang.treeAlignment}
                    </PageMenuButton>
                </PageMenu>

                <Tab show={objectiveRoute === okrObjectivesAllRoute}>
                    <ListAll dataLoadedCallback={() => setDataLoaded(true)} />
                </Tab>
                <Tab show={objectiveRoute === okrObjectivesNestedRoute}>
                    nested
                </Tab>
                <Tab show={objectiveRoute === okrObjectivesTreeRoute}>
                    tree
                </Tab>
            </PageContent>
        </Container>
    )
}
export default ObjectiveList
